import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import {
  getUpdateMedicationPadItems,
  updateReissueAndCancelWhenChangingProducts,
} from '../utils/updateMedicationPadItems';

export const updateMedicationPadItemById: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (updatedMedicationPadItem: MedicationPadItemType) => void
> = (set, get) => (updatedMedicationPadItem) => {
  const { prescriptionAssistant, updatePrescriptionHistoryItemsToReissue, updatePrescriptionHistoryItemsToCancel } =
    get();
  // Update medication pad items
  const { updatedItems, previousProductId, updatedItem, dispenseLimits } = getUpdateMedicationPadItems(
    prescriptionAssistant.prescriptionPad.medicationPadItems,
    updatedMedicationPadItem,
    prescriptionAssistant.prescriptionHistory.previousItems,
    prescriptionAssistant.prescriptionPad.dispenseLimits,
    prescriptionAssistant.prescriptionPadRules,
  );

  const {
    updatedCancelledItems,
    updatedReissuedItems,
    updatedMedicationPadItem: latestMedicationPadItem,
  } = updateReissueAndCancelWhenChangingProducts(
    updatedItem ?? updatedMedicationPadItem,
    prescriptionAssistant.prescriptionHistory.previousItems,
    prescriptionAssistant.prescriptionHistory.itemsToReissue,
    prescriptionAssistant.prescriptionHistory.itemsToCancel,
    previousProductId,
  );

  updatePrescriptionHistoryItemsToCancel(updatedCancelledItems);
  updatePrescriptionHistoryItemsToReissue(updatedReissuedItems);

  set(
    (state) => {
      state.prescriptionAssistant.prescriptionPad.medicationPadItems = updatedItems.map((item) => {
        if (item.medicationPadItemId === latestMedicationPadItem?.medicationPadItemId) {
          return latestMedicationPadItem;
        }
        return item;
      });
      state.prescriptionAssistant.prescriptionPad.dispenseLimits = dispenseLimits;
    },
    false,
    'prescriptionPad/updateMedicationPadItemById',
  );
};
